import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ServerIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "server",
  "ServerIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M3.6665 5.66659H7.33317V4.33325H3.6665V5.66659Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M7.33317 11.6666H3.6665V10.3333H7.33317V11.6666Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M0.666504 1.33325H15.3332V14.6666L0.666504 14.6666V1.33325ZM13.9998 2.66659V7.33325H1.99984V2.66659H13.9998ZM1.99984 8.66659V13.3333H13.9998V8.66659H1.99984Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default ServerIcon;
